<template>
  <el-row :gutter="20" style="height: 100%; margin-bottom: 0" type="flex">
    <el-col :lg="7" :md="9" style="height: 100%">
      <ChatSessionSummary @refreshSummary="refreshSummary" />
    </el-col>
    <el-col :lg="17" :md="15" style="height: 100%">
      <AgentSessionDetails />
    </el-col>
  </el-row>
</template>

<script>
import { notifyWebsocketReconnected } from "@/helperMethods/notifyError";
import socketRecovery from "@/mixins/socketRecovery";
import ChatSessionSummary from "@/views/Supervisor/ChatSessionSummary";
import AgentSessionDetails from "@/views/Supervisor/AgentSessionDetails";

export default {
  mixins: [socketRecovery],
  data() {
    return {
      currentMode: "",
      selectedChatSession: null,
      currentExpanded: null,
    };
  },
  components: {
    ChatSessionSummary,
    AgentSessionDetails,
  },
  methods: {
    refreshSummary() {
      this.refreshAgentsSummary()
      .then((refreshed) => {
        if (refreshed) {
          this.$store.dispatch('supervisor/SHOW_ONLINE_AGENTS');
        }
      });
      this.$store.dispatch("supervisor/SHOW_AGENT_LIST", { status: null });
      this.$store.commit("supervisor/SET_SELECTED_CHAT_SESSION", null);
      this.fetchChats();
    },
    /**
     * Re-fetch the agent summary without disturbing the current selection.
     *
     * The summary is only fetched when AgentSessionList mounts, so a fetch that failed — which
     * happens whenever the socket is down, since the resolver keys off the live status map — left
     * the monitor reading "0 agents" until someone pressed refresh (KR-10982).
     */
    refreshAgentsSummary() {
      return this.$store.dispatch("supervisor/FETCH_AGENTS_WITH_CHAT_COUNT", {
        email: this.$store.state.profile.email,
      });
    },
    fetchChats() {
      this.fetchInQueueChats();
      this.fetchOnGoingChats();
      this.fetchAbandonedChats();
      this.fetchResolvedChats();
    },
    fetchInQueueChats() {
      this.$store.dispatch("supervisor/FETCH_IN_QUEUE_CHATS");
    },
    fetchOnGoingChats() {
      this.$store.dispatch("supervisor/FETCH_ON_GOING_CHATS");
    },
    fetchAbandonedChats() {
      this.$store.dispatch("supervisor/FETCH_ABANDONED_CHATS");
    },
    fetchResolvedChats() {
      this.$store.dispatch("supervisor/FETCH_RESOLVED_CHATS");
    },
  },
  mounted() {
    this.fetchChats();
    this.listenForSocketRecovery(({ isRecovery }) => {
      this.fetchChats();
      // The agent summary is derived from the socket status map, so anything fetched while the
      // socket was down is missing or stale — pull it again now that we are back. This runs on
      // every connect this view sees, because the socket is usually already up by the time the
      // monitor mounts and the first event it receives is a real reconnect (KR-10982).
      this.refreshAgentsSummary();
      if (isRecovery) {
        notifyWebsocketReconnected();
      }
    });
  },
  beforeDestroy() {
    this.$store.dispatch("supervisor/FLUSH_SUPERVISOR_DATA");
    this.stopListeningForSocketRecovery();
  },
};
</script>
